import Router from './Router';
import { Provider } from 'react-redux';
import store from "./reduxStore/Store";
import { initMonitoring } from "@kfintech/website-monitoring-sdk";


function App() {
  initMonitoring({
 appName: "nps",
 env: "prod",
 apiUrl: "/Analysis/WebsiteMonitoringSaving",
 enableClicks: false,
 enableErrors: true,
 enableVitals: true,
 sampleRate: 0.3,
 debug: true,
 maskKeys: [
 "password",
 "token",
 "pan",
 "aadhaar",
 ],
});

  return (
    <>
      <Provider store={store}>
        <Router />
      </Provider>
    </>
  );
}


export default App;
